import { defineStore } from "pinia";

export const useDialogStore = defineStore("dialogStore", {
  state: () => ({
    isDialogVisible: false,
    zIndexValue: 40,
    oneTimeVisible: false,
  }),
  actions: {
    showDialog() {
      this.isDialogVisible = true;
    },
    hideDialog() {
      this.isDialogVisible = false;
    },
  },
});
